import axios from 'axios';

export const correios = axios.create({
    baseURL: 'https://viacep.com.br/ws'
})